import React from "react";
import HowWeHelp from "../components/HowWeHelp";
import GlobalImpactHero from "../components/GlobalImpactHero";
import GlobalFlags from "../components/GlobalFlags";
import GoogleMapWithCircle from "../components/GoogleMap";

const OurGlobalImpactPage = () => {
    return (
        <div>
            <GlobalImpactHero />
            <GlobalFlags />
            <GoogleMapWithCircle />
            <HowWeHelp />
        </div>
    );
};

export default OurGlobalImpactPage;
